import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from './router'
import i18n, { loadLocale, isSupportedLocale, matchLocale, type SupportedLocale } from './i18n'
import App from './App.vue'
import './assets/styles/main.css'
import { captureAttributionOnLoad } from './utils/attribution'
import { installGlobalErrorHooks } from './utils/errorReporter'

// Capture signup attribution (utm_*/gclid/fbclid/referrer) on first landing, so
// a subscription checkout can be traced back to where it came from. Best-effort.
captureAttributionOnLoad()

window.__PJ_VERSION = typeof __PJ_VERSION__ !== 'undefined' ? __PJ_VERSION__ : 'dev';
console.info(`[ProfitJam] v${window.__PJ_VERSION}`)
console.info(`[ProfitJam] build ${__BUILD_VERSION__} (${__BUILD_HASH__})`)

function detectInitialLocale(): SupportedLocale {
  try {
    const raw = localStorage.getItem('auth_user')
    if (raw) {
      const user = JSON.parse(raw)
      if (isSupportedLocale(user.language)) return user.language
    }
  } catch { /* ignore */ }
  return matchLocale(navigator.language)
}

async function bootstrap() {
  const initialLocale = detectInitialLocale()
  await loadLocale(initialLocale)
  i18n.global.locale.value = initialLocale

  const app = createApp(App)
  app.use(createPinia())
  installGlobalErrorHooks(app)
  app.use(i18n)
  app.use(router)
  app.mount('#app')
}

bootstrap()
